import { Reason } from '../types';

/**
 * Datos de por qué elegir Conectemos Chile
 */
export const reasons: Reason[] = [
  {
    id: 'certificados',
    icon: 'fas fa-certificate',
    title: 'Profesionales Certificados',
    description: 'Nuestro equipo cuenta con certificaciones oficiales y formación constante para entregarte una atención confiable y de calidad.'
  },
  {
    id: 'modalidad',
    icon: 'fas fa-clock',
    title: 'Disponibilidad en Modalidad y Horarios',
    description: 'Elige entre atención presencial u online, con alternativas en horario diurno y vespertino para mayor comodidad.'
  },
  {
    id: 'personalizado',
    icon: 'fas fa-heart',
    title: 'Enfoque Personalizado',
    description: 'Diseñamos un plan terapéutico adaptado a tus necesidades y objetivos, acompañándote en cada etapa de tu proceso.'
  },
  {
    id: 'reembolsables',
    icon: 'fas fa-file-invoice-dollar',
    title: 'Boletas Reembolsables',
    description: 'Todas nuestras boletas son reembolsables con cualquier Isapre y/o seguro complementario, facilitando el acceso a tu terapia.'
  }
];